import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import LanguageSelect from "./Dashboard/LanguageSelect";

const LanguageSelectBanner = ({ selectedLanguage, setSelectedLanguage }) => {
    const { t } = useTranslation();

    useEffect(() => {
        const lastSelectedLanguage = localStorage.getItem("lastSelectedLanguage");
        if (lastSelectedLanguage) {
            setSelectedLanguage(lastSelectedLanguage);
        }
    }, [setSelectedLanguage]);

    return (
        <div className="flex flex-col items-center justify-center mt-8 mb-2 px-4">
            <div className="flex items-center justify-center gap-2">
                <h1 className="text-large sm:text-xl md:text-2xl lg:text-3xl font-semibold text-balance">
                    {t("languageSelectBanner.title")}
                </h1>
                <div className="font-medium text-large sm:text-2xl md:text-3xl lg:text-4xl">
                    <LanguageSelect
                        selectedLanguage={selectedLanguage}
                        setSelectedLanguage={setSelectedLanguage}
                    />
                </div>
            </div>
        </div>
    );
};

export default LanguageSelectBanner;
